module.exports = __webpack_public_path__ + "static/img/ico-click.6ed6d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-click.png
// module id = 1vZX
// module chunks = 2